// The three sections of a girone, named once so the type derives from the values and the
// search param cannot hold a fourth. Same order as the backoffice's girone card.

export const LEAGUE_SECTIONS = ['entries', 'calendar', 'standings'] as const

export type LeagueSection = (typeof LEAGUE_SECTIONS)[number]
